import * as stylex from '@stylexjs/stylex';
import '~styles/theme.stylex';
import { colors, font, radius } from '~styles/theme.stylex';
export const styles = {
  topRow: {
    display: "x78zum5",
    alignItems: "x6s0dn4",
    justifyContent: "x1qughib",
    gap: "x8fetqu",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  left: {
    display: "x78zum5",
    alignItems: "x6s0dn4",
    gap: "x1fsutb",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  icon: {
    color: "x1gonuu0",
    $$css: true
  },
  label: {
    color: "xarw3lm",
    fontSize: "x6u19be",
    $$css: true
  },
  count: {
    fontSize: "x1603h9y",
    fontWeight: "x1sl8krj",
    color: "xtt1gjl",
    $$css: true
  },
  total: {
    color: "xarw3lm",
    fontWeight: "x17i1jlu",
    $$css: true
  },
  track: {
    marginTop: "xhj8ucd",
    height: "x164u9eo",
    width: "xh8yej3",
    borderRadius: "xjiwlmt",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    backgroundColor: "x4aap8p",
    overflow: "xb3r6kr",
    overflowX: null,
    overflowY: null,
    $$css: true
  },
  fill: {
    height: "x5yr21d",
    borderRadius: "xjiwlmt",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    backgroundColor: "xwk94rn",
    $$css: true
  },
  fillFull: {
    backgroundColor: "x1yi5t32",
    $$css: true
  }
};